import { LeadsScreen } from "../leads"

export const SalesLeads = () => {
    return (
        <LeadsScreen />
    )
}